import type {AppError, ErrorService} from '@/domain/interfaces/ErrorService';

export class SubscribeToErrorsUseCase {
  constructor(private readonly errorService: ErrorService) {}

  execute = (onError: (error: AppError) => void) => {
    return this.errorService.subscribe(onError);
  };
}
